import React, { MouseEventHandler } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { translate } from 'containers/services/translate';
import messages from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/messages';
import SahamDialog from 'components/SahamDialog';

export interface ValidationDialogProps {
  intl: IntlShape;
  open: boolean;
  handleClose: Function;
  handleValidate: any;
}

const ValidationDialog: React.FC<ValidationDialogProps> = (
  props,
): JSX.Element => {
  return (
    <SahamDialog
      handleValidate={props.handleValidate}
      handleClose={props.handleClose as MouseEventHandler}
      title={translate(messages.courtManagerConfirmationDialogTitle, props)}
      cancelTitle={translate(
        messages.courtManagerConfirmationDialogCancel,
        props,
      )}
      confirmTitle={translate(
        messages.courtManagerConfirmationDialogConfirm,
        props,
      )}
      open={props.open}
    >
      {translate(messages.validateAfterRejectionTitle, props)}
    </SahamDialog>
  );
};

export default injectIntl(ValidationDialog);
